<template>
  <div class="membership">
    <div v-if="membershipInfo" class="membership-info">
      <h3>Your Membership Status</h3>
      <el-descriptions :column="1" border>
        <el-descriptions-item label="Join Date">
          {{ formatDate(membershipInfo.join_time*1000) }}
        </el-descriptions-item>
        <el-descriptions-item label="Status">
          {{ membershipInfo.status }}
        </el-descriptions-item>
      </el-descriptions>
    </div>
    <div v-else class="no-membership">
      You are not a member of this club.
    </div>
  </div>
</template>

<script>
import { postRequest } from '@/api/eclub'
import { getUserId } from '@/utils/store'

export default {
  name: 'Membership',
  props: {
    club_id: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      membershipInfo: null
    }
  },
  created() {
    this.fetchMembershipInfo()
  },
  methods: {
    async fetchMembershipInfo() {
      try {
        const response = await postRequest('getClubUser', {
          user_id: getUserId(),
          club_id: this.club_id
        })
        this.membershipInfo = response.data.data
      } catch (error) {
        console.error('Error fetching membership info:', error)
      }
    },
    formatDate(date) {
      if (!date) return '-'
      return new Date(date).toLocaleDateString()
    }
  }
}
</script>

<style scoped lang="scss">
.membership {
  padding: 20px;

  .membership-info {
    max-width: 600px;
    margin: 0 auto;
  }

  .no-membership {
    text-align: center;
    color: #666;
    padding: 40px;
  }

  h3 {
    margin-bottom: 20px;
  }
}
</style> 